module.exports = __webpack_public_path__ + "static/media/vaccination-schedule.11bd2265.png";